import { render } from "./PageLayout.vue?vue&type=template&id=93c1ee46&ts=true"
import script from "./PageLayout.ts?vue&type=script&lang=ts&external"
export * from "./PageLayout.ts?vue&type=script&lang=ts&external"

import "./PageLayout.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__